export default "../media/icon_social_instagram.462cb89e6b8627985000b15621b68db6.svg";